var _path, _path2, _g, _g2, _circle, _ellipse, _path3, _path4, _circle2, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _ellipse2, _path15, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoaccesscode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 248,
    viewBox: "0 0 248 248",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M243.97 222.956C250.016 211.363 233.912 152.804 117.068 151.308C32.7298 150.228 -6.59047 197.487 1.65734 221.798",
    fill: "url(#paint0_radial_8193_186932)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8193_186932",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 151,
    width: 246,
    height: 72
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M243.97 222.956C250.016 211.363 233.912 152.804 117.068 151.308C32.7298 150.228 -6.59047 197.487 1.65734 221.798",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8193_186932)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.671968,
    cx: 98.6263,
    cy: 183.795,
    rx: 6.42639,
    ry: 3.56955,
    transform: "rotate(0.733676 98.6263 183.795)",
    fill: "url(#paint1_linear_8193_186932)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.729957,
    cx: 164.285,
    cy: 179.187,
    rx: 10.1394,
    ry: 5.56849,
    transform: "rotate(0.733676 164.285 179.187)",
    fill: "url(#paint2_linear_8193_186932)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.729957,
    cx: 49.0932,
    cy: 162.86,
    rx: 10.1394,
    ry: 5.56849,
    transform: "rotate(0.733676 49.0932 162.86)",
    fill: "url(#paint3_linear_8193_186932)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.320685
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 192.278,
    cy: 54.9407,
    rx: 6.85482,
    ry: 6.85353,
    transform: "rotate(0.733676 192.278 54.9407)",
    fill: "url(#paint4_linear_8193_186932)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.05 49.4521C185.114 48.9998 182.959 49.2973 182.541 50.4011C181.871 52.171 185.92 55.344 191.585 57.488C197.25 59.6321 202.386 59.9353 203.056 58.1653C203.478 57.0516 201.631 55.4622 199.089 53.8434",
    stroke: "url(#paint5_linear_8193_186932)",
    strokeWidth: 4.20561
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.148 55.0298C199.197 51.245 196.167 48.1375 192.382 48.089C188.596 48.0405 186.194 50.43 185.67 53.1522C185.67 53.1522 189.579 55.6693 191.391 56.2228C191.969 56.3993 192.542 56.626 193.125 56.828C193.777 57.0538 194.442 57.2542 195.115 57.4293C195.575 57.5491 196.206 57.7333 196.796 57.8508C197.574 58.0058 198.272 58.0794 198.327 58.0801C198.423 58.0814 198.535 57.6518 198.759 57.1525C198.984 56.6532 199.148 55.0298 199.148 55.0298Z",
    fill: "url(#paint6_linear_8193_186932)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.418364,
    cx: 41.1643,
    cy: 93.4413,
    r: 7.9929,
    transform: "rotate(0.733676 41.1643 93.4413)",
    fill: "url(#paint7_linear_8193_186932)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 126.796,
    cy: 162.718,
    rx: 23.9787,
    ry: 6.58239,
    transform: "rotate(0.733676 126.796 162.718)",
    fill: "url(#paint8_linear_8193_186932)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M119.34 27.0664L121.979 28.0651L71.2108 162.18C70.935 162.908 70.1209 163.275 69.3923 163C68.6638 162.724 68.2967 161.91 68.5725 161.181L119.34 27.0664Z",
    fill: "#D8D8D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M119.272 27.1309L139.911 41.1113C141.608 42.2606 143.509 43.0741 145.512 43.5079C156.351 45.8551 163.301 56.4652 161.123 67.3392L155.869 93.5636C155.845 93.685 155.672 93.6863 155.643 93.5657C153.48 84.3357 144.879 78.0309 135.43 78.8008C131.125 79.1515 126.876 77.6459 123.752 74.6633L107.246 58.9019L119.272 27.1309Z",
    fill: "#D42620"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 120.444,
    cy: 26.6923,
    r: 1.88068,
    transform: "rotate(20.7337 120.444 26.6923)",
    fill: "#D8D8D8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9161 107.264C87.9161 107.264 89.3355 106.577 89.3325 106.812C89.3295 107.047 89.2964 109.633 89.2964 109.633L88.3501 110.091L87.9161 107.264Z",
    fill: "#FFE9E9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M114.022 154.689C114.022 154.689 113.57 152.955 112.324 152.827C111.077 152.699 107.515 156.372 106.76 157.898C106.006 159.424 107.985 161.601 110.303 159.562C112.621 157.524 114.022 154.689 114.022 154.689Z",
    fill: "#677285"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M115.427 159.753L114.045 155.736C113.489 154.118 111.298 153.885 110.413 155.35C110.237 155.642 110.137 155.971 110.138 156.313C110.141 157.93 110.343 162.825 112.626 163.514C115.368 164.341 115.427 159.753 115.427 159.753Z",
    fill: "url(#paint9_linear_8193_186932)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M133.181 154.935C133.181 154.935 133.678 153.212 134.927 153.116C136.176 153.02 139.643 156.783 140.358 158.328C141.073 159.873 139.039 161.999 136.774 159.901C134.509 157.804 133.181 154.935 133.181 154.935Z",
    fill: "#677285"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M131.648 159.96L133.132 155.98C133.73 154.377 135.926 154.2 136.773 155.687C136.942 155.983 137.033 156.315 137.024 156.657C136.979 158.273 136.652 163.161 134.352 163.792C131.589 164.548 131.648 159.96 131.648 159.96Z",
    fill: "url(#paint10_linear_8193_186932)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M115.983 147.75C115.983 147.75 115.177 149.284 115.163 150.37C114.354 152.121 113.028 154.474 110.721 159.388C109.317 162.38 111.496 163.363 113.416 163.674C114.939 163.921 116.423 163.281 117.629 162.318L123.348 157.751L130.413 163.738C131.695 164.824 133.569 164.841 134.87 163.778C136.207 162.684 136.577 160.755 135.835 159.196C135 157.443 133.763 154.698 132.07 150.586C132.084 149.512 131.411 148.473 131.411 148.473L115.983 147.75Z",
    fill: "url(#paint11_linear_8193_186932)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M133.253 135.747C134.511 137.637 134.109 142.316 134.109 142.316L130.348 142.268L131.695 152.197C131.777 152.8 131.432 153.379 130.857 153.58C129.076 154.198 125.262 155.429 122.786 155.544C120.303 155.659 116.165 154.369 114.235 153.711C113.627 153.503 113.289 152.879 113.472 152.263C113.931 150.716 115.048 147.444 117.542 142.104C118.315 143.032 113.893 142.058 113.893 142.058C113.893 142.058 114.224 137.89 115.388 135.518C116.552 133.146 119.2 131.586 119.2 131.586L125.856 130.662C125.856 130.662 128.609 131.236 130.009 132.006C131.41 132.775 131.994 133.857 133.253 135.747Z",
    fill: "url(#paint12_linear_8193_186932)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M133.753 142.294L133.547 146.747L133.013 148.97L129.358 163.248L129.896 164.45L130.234 166.006L129.864 166.989L128.928 166.626L127.067 165.072L126.771 164.143C126.672 163.833 126.708 163.495 126.872 163.213L127.767 161.669L130.461 148.33L130.283 142.418L133.753 142.294Z",
    fill: "#FDE7E6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M113.986 142.209L114.337 146.501L114.813 148.737L118.101 163.104L117.532 164.291L117.155 165.838L117.5 166.83L118.445 166.491L120.345 164.986L120.665 164.064C120.772 163.757 120.744 163.418 120.588 163.133L119.732 161.565L117.381 148.162L117.653 142.256L113.986 142.209Z",
    fill: "#FDE7E6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.5 127.01L121.797 126.963L121.733 131.926L125.437 131.973L125.5 127.01ZM123.179 134.786C123.188 134.082 121.734 131.927 121.734 131.927L125.437 131.974C125.437 131.974 123.17 135.491 123.179 134.786Z",
    fill: "#FECECD"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 123.446,
    cy: 126.163,
    rx: 3.28356,
    ry: 4.88977,
    transform: "rotate(0.733676 123.446 126.163)",
    fill: "#FFE9E9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.832 126.932C120.107 126.004 120.133 123.948 120.659 123.888C121.185 123.828 122.231 124.23 123.291 123.489C123.822 123.081 124.085 123.033 124.088 122.824C126.708 123.354 125.118 124.831 126.405 126.496C126.54 126.67 126.931 126.503 126.931 126.503C126.931 126.503 126.983 122.443 126.725 122.078C126.467 121.712 125.435 120.24 124.896 121.274C124.903 120.754 123.859 120.204 122.803 120.589C121.747 120.973 120.161 121.734 119.885 122.771C119.609 123.808 119.32 125.885 119.832 126.932Z",
    fill: "#513450"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_8193_186932",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(107.123 176.139) rotate(-89.2663) scale(41.8404 436.981)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEDF0",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536775,
    stopColor: "#EBEDF0",
    stopOpacity: 0.845525
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E4E7",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8193_186932",
    x1: 93.4536,
    y1: 182.849,
    x2: 95.4114,
    y2: 187.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E7EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D6DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8193_186932",
    x1: 155.771,
    y1: 178.666,
    x2: 159.353,
    y2: 186.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E7EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D6DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8193_186932",
    x1: 42.6281,
    y1: 162.95,
    x2: 44.6552,
    y2: 171.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8193_186932",
    x1: 182.914,
    y1: 50.2214,
    x2: 186.341,
    y2: 62.0711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.717538,
    stopColor: "#E1E7EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC3CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8193_186932",
    x1: 187.705,
    y1: 55.0315,
    x2: 202.17,
    y2: 60.5071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAC6D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F8F9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8193_186932",
    x1: 189.767,
    y1: 54.3198,
    x2: 191.95,
    y2: 58.8763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E7EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D6DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_8193_186932",
    x1: 51.6723,
    y1: 95.8136,
    x2: 43.6911,
    y2: 82.3348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE2E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E3EBEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF6F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_8193_186932",
    x1: 108.797,
    y1: 163.498,
    x2: 122.265,
    y2: 184.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CDD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6CFD3",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_8193_186932",
    x1: 115.377,
    y1: 163.666,
    x2: 115.511,
    y2: 153.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A87AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444F77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_8193_186932",
    x1: 131.598,
    y1: 163.873,
    x2: 131.732,
    y2: 153.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A87AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444F77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_8193_186932",
    x1: 136.208,
    y1: 164.585,
    x2: 136.42,
    y2: 148.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A87AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444F77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_8193_186932",
    x1: 144.64,
    y1: 142.288,
    x2: 122.98,
    y2: 164.916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E9F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2DAE8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoaccesscode);
export default __webpack_public_path__ + "static/media/noaccesscode.172d94432f209593186832759e36ad7f.svg";
export { ForwardRef as ReactComponent };